import { useCallback, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { selectDashboards } from "./dashboardSlice";
import { dashboardDataRequestThunk } from "./dashboardThunks";

export const useFetchPanelData = (dashboardId, panel) => {
    const dispatch = useDispatch();
    
    const panelKey = panel?.unique_id || panel?.id;
    const panelRef = useRef(panel);

    useEffect(() => {
        panelRef.current = panel;
    }, [panel]);

    const selectPanel = useMemo(
        () => createSelector(
            [selectDashboards],
            (dashboards) => dashboards[dashboardId]?.panels?.[panelKey] || null
        ),
        [dashboardId, panelKey]
    );

    const panelObject = useSelector(selectPanel);

    const fetchPanelData = useCallback(() => {
        dispatch(
            dashboardDataRequestThunk({ 
                dashboardId,
                panel: panelRef.current,
            })
        ).catch((err) => {
            console.error(`Failed to refresh panel ${panelKey}:`, err);
        });
    }, [dispatch, dashboardId, panelKey]);

    return { panelObject, fetchPanelData };
};
